/**
 * Created by cuppi on 2017/10/16.
 */

export default {
  baseUrl: 'https://local.idoupiao.com:5743/xcebfilm',
  isSimulateLogin: true
}
